import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { Router } from "@angular/router";

import { BaseService } from "./base.service";
import { Upload } from "../models/upload.model";

@Injectable()
export class ApprovalService extends BaseService {
  constructor(protected http: Http) {
    super(http);
  }

  async getPendingApprovals(): Promise<Array<Upload>> {
    return this.get("pendingApprovals");
  }

  async approve(ids: string[], comment?: string): Promise<any> {
    return this.post("pendingApproval/approve", { uploadIds: ids, comment });
  }

  async reject(
    id: string,
    item: any,
    reasonText: string,
    rejectionReasons: Object
  ): Promise<any> {
    return this.post("pendingApproval/" + id + "/deny", {
      item: item,
      reasonText: reasonText,
      rejectionReasons: rejectionReasons,
    });
  }

  async clearAwaitingReupload(uploadId: number): Promise<any> {
    return this.delete("clearAwaitingReupload/" + uploadId);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/approval.service.ts